import { CampaignMaterialsFoldersController } from './campaign-materials-folders.controller'

function campaignMaterialsFolders () {
  return {
    scope: {
      campaign: '=',
      folders: '=',
      reloadCollections: '&',
      openCollection: '<',
      selectedMaterials: '=',
      headerButton: '<',
      selectedScheduleDate: '<'
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-materials-folders/campaign-materials-folders.html?$$REVISION$$',
    controller: CampaignMaterialsFoldersController
  }
}

export { campaignMaterialsFolders }
